import { Type } from "class-transformer";
import { ClientSituation } from "./type/client-situation.enum";

export class ClientHistoryOutDTO {
  @Type(() => Date)
  createdAt!: Date;

  situation?: ClientSituation[];
}
